import React, { ChangeEvent } from "react";
import styles from "./styles.module.scss";

interface IProps {
    value: string;
    onChange: (value: string) => void;
    maxLength?: number;
    placeholder?: string;
    required?: boolean;
}

const Textarea: React.FC<IProps> = ({ placeholder, value, onChange, maxLength, required }) => {
    return (
        <div className={styles.textarea_container}>
            <textarea
                value={value}
                onChange={(e: ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
                rows={10}
                placeholder={placeholder}
                maxLength={maxLength}
                required={required} 
            />
            {maxLength
                ? <span className={styles.max_lenght_label}>
                    {value.length}/{maxLength}
                </span>
                : null
            }
        </div>
    );
};

export default Textarea;